var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "webhooks-modal",
      attrs: {
        visible: _vm.showModal,
        size: "large",
        title: _vm.$t.__(
          "developerPage.WebhooksForms.WebhooksModal.configure_webhook"
        )
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: _vm.closeModal
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "dialog__default" },
          [
            _c("preloader", { attrs: { display: _vm.loading } }),
            _vm._v(" "),
            !_vm.loading
              ? _c(_vm.config.type, {
                  tag: "component",
                  attrs: {
                    id: _vm.config.id,
                    hookType: _vm.config.type,
                    logs: _vm.logs
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }